module.exports = __webpack_public_path__ + "12_hair_silver.672c769f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/12_hair_silver.png
// module id = uLuE
// module chunks = 0